export default { sha: 'caf5bde7d8e7de6367dce4a274ba2f99cc22b3d7', buildNumber: 'undefined' }
